const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Preferenze lead',
    confirmMessage: 'Sicuro di voler salvare le tue preferenze lead e accedere alla pagina Aggiungi utente?',
    notInterested: {
      radioOptions0: 'Mancanza di tempo/risorse per servire nuovi lead',
      radioOptions1: 'Interessato solo ai contratti di proprietari di casa già firmati',
      radioOptions2: 'Non voglio divulgare la fascia di prezzo',
      radioOptions3: 'Altro',
      selectReason: "Seleziona almeno una ragione per decidere di non far parte dell'Enphase Leads Program",
      otherComments: 'Eventuali altri commenti'
    },
    programOverview: {
      notInterestedText: "Non siamo interessati a partecipare all'Enphase Leads Program in questo momento"
    },
    serviceDetailsSection: {
      min: 'Min',
      max: 'Max',
      maxLessMin: 'Il valore Max non può essere inferiore o uguale al valore Min',
      enterInRange: 'Inserisci solo numeri compresi tra %{serviceMInValue} e %{serviceMaxValue}',
      note: 'Nota',
      noteText:
        'Al proprietario di casa verrà mostrata la fascia di prezzo basa su questo input. Questo prezzo deve includere le tasse, ma non gli incentivi.',
      noteTextAus:
        "Al proprietario di casa verrà mostrata la fascia di prezzo basa su questo input. Questo prezzo deve includere l'imposta sui bei e sui servizi, ma non gli incentivi.",
      sizeRange: 'Gamma di dimensioni',
      pricePerkWh: 'Prezzo per kWh',
      lessThan20kWh: 'Meno di 20 kWh',
      greaterThan20kWh: 'Da 20 a 40 kWh'
    },
    serviceAreaSection: {
      title: 'Accesso amministratore e area dei servizi',
      manageAdminAccess: 'Gestisci accesso amministratore',
      addNewUser: '+ Aggiungi nuovo utente',
      selectOneAdmin:
        "Seleziona un utente amministratore dell'azienda che rappresenterà l'unico punto di contatto nel caso in cui Enphase desiderasse contattarti per risolvere questioni correlate a un lead.",
      selectUser: 'Seleziona utente',
      otherAdmin:
        "#Gli altri utenti amministratori presenti nell'elenco di cui sopra riceveranno comunque gli avvisi per tutti i nuovi lead e i relativi aggiornamenti. Se necessario, possono disattivare questi avvisi aggiornando le loro preferenze riguardo alle notifiche.",
      serviceArea: 'Area dei servizi',
      addServiceAreas: ''
    },
    addUserDialog: {
      yes: 'Sì'
    },
    acModule: {
      optIn: "Autorizzazione all'installazione di Moduli CA energizzati Enphase",
      description:
        "Il proprietario di casa esprime interesse per un sistema basato sul modulo CA. Acquisirai e installerai i moduli CA. I moduli CA energizzati Enphase combinano la più recente tecnologia all'avanguardia dei microinverter Enphase con pannelli solari ad alta efficienza. Combinano estetica e prestazioni in un prodotto elegante che riduce i tempi di installazione combinando l'inverter e il pannello in un'unica unità."
    },
    sampleQuotes: {
      title: 'Prezzi indicativi per i lead',
      useSlider:
        'Usa i cursori per vedere in che modo la fascia di prezzo che hai inserito si traduce in una fascia di prezzo indicativa per i Proprietari di casa per sistemi con correnti diverse',
      description:
        'In base ai tuoi input, la fascia di prezzo indicativa che vedranno i proprietari di casa verrà visualizzata qui. Puoi verificare anche il modo in cui la fascia di prezzo varia in base alla corrente del sistema.',
      solarOnly: 'Installazione impianto solare',
      storageOnly: 'Installazione spazio di accumulo',
      solarStorage: 'Installazione impianto + spazio di accumulo',
      solarExpansion: 'Espansione impianto solare',
      turnkeyACM: 'Installazione spazio di accumulo + Aggiornamento ACM',
      microUpgrade: 'Aggiornamento microinverter',
      turnkeyIQSeries: 'Installazione spazio di accumulo + Aggiornamento microinverter',
      installationACM: 'Installazione spazio di accumulo + Aggiornamento ACM',
      installationIQSeries: 'Installazione spazio di accumulo + Aggiornamento microinverter',
      installationSolar: 'Installazione impianto solare',
      installationStorage: 'Installazione/espansione impianto solare',
      turnkeyNew: 'Prezzo chiavi in mano per i nuovi proprietari di casa',
      turnKeyExisting: 'Prezzo chiavi in mano per i proprietari di casa esistenti',
      turnkeyNewUS: 'Prezzo chiavi in mano per i proprietari di casa',
      installationUS: 'Prezzo solo installazione per i proprietari di casa',
      installation: 'Preventivi per la sola installazione per i clienti di M-190 Micro',
      turnkeyPrice: 'Prezzo chiavi in mano',
      installation2: 'Prezzo per la sola installazione per i clienti raccomandati',
      installation3: 'Prezzo per la sola installazione per i clienti esistenti',
      microinverterFootnote: `A seconda degli anni del sito, è possibile aggiungere il prezzo per l'aggiornamento dei microinverter`,
      solar: 'Impianto solare',
      storage: 'Spazio di accumulo'
    },
    operationMaintenance: {
      label: 'Autorizzazione ai servizi O&M',
      description:
        "I servizi Operations and Maintenance (O&M) includono l'assistenza e la manutenzione dei sistemi Enphase e Orfani esistenti (siti con un installatore inattivo). A tutti i lead O&M verranno forniti i dettagli completi del sito e la cronologia dell'assistenza. Per tutti i lead O&M si applica la garanzia dei prodotti Enphase standard. La precedente garanzia da difetti di fabbricazione non si applica ai sistemi orfani."
    },
    leadProgram: {
      optIn: "Autorizzazione all'Enphase Leads Program",
      description:
        "I proprietari di case contattano Enphase per nuove installazioni, aggiornamenti e manutenzione regolare del sistema. In qualità di partner di Enphase, ora hai l'opportunità di servire questi proprietari di casa attraverso l'Enphase Leads, che ti metterà in contatto con potenziali proprietari di case.",
      programHighlights: 'Aspetti salienti del programma:',
      keyTerms1: 'Enphase fornirà lead qualificati gratuiti per la tua area di assistenza',
      keyTerms2:
        'Il profilo del cliente e i dettagli del progetto saranno forniti per ciascun lead prima del primo contatto',
      keyTerms3:
        "Enphase fornirà assistenza per la pianificazione, l'appuntamento, gli aggiornamenti del progetto e il supporto tecnico",
      keyTerms4:
        'Gli installatori devono rispondere e contattare ciascun lead inviando un preventivo entro 2 giorni lavorativi',
      keyTerms5: "Nell'ambito del programma devono essere utilizzati solo prodotti Enphase",
      leadProgramPreferences: 'Preferenze del programma lead',
      someLeads:
        'Alcuni lead potrebbero richiedere solo servizi di installazione. Indica di seguito se desideri attivare tali lead.',
      tooltipTitle1:
        'Servizi da te forniti ai proprietari di case. Enphase ti assocerà ai proprietari di case in base alle tue preferenze di assistenza selezionate',
      turnKey: 'Servizi chiavi in mano',
      tooltipTitle2: 'Fornisci tutti i servizi relativi ad attrezzatura, progettazione, autorizzazione e installazione',
      installationService: 'Servizi di sola installazione',
      tooltipTitle3:
        "Il proprietario di casa sceglie di procurarsi l'apparecchiatura Enphase nel negozio Enphase. Tu fornisci le apparecchiature rimanenti, i servizi di progettazione, autorizzazione e installazione",
      solarNew: 'Impianto solare - Nuove installazioni',
      solarUpgrades: 'Impianto solare - Aggiornamenti',
      storageNew: 'Spazio di accumulo - Nuove installazioni'
    },
    textContent: {
      preference: {
        title: 'Preferenze del programma lead',
        caption: 'Limitazione di responsabilità',
        description:
          "Enphase mostrerà ai proprietari di case la fascia di prezzo da te fornita per ciascuna preferenza indicata di seguito. Verrà mostrata insieme a un'esclusione di responsabilità indicante che questo prezzo dipendente dal budget e riflette solo l'ambito di lavoro di un sistema tipico. Il prezzo effettivo è soggetto a modifiche a seconda della posizione, del tipo o della pendenza del tetto, dell'aggiornamento del quadro elettrico e della risistemazione del sistema in un luogo diverso.",
        atleaseOne: '*seleziona almeno un servizio'
      },
      programreview: {
        title: 'Panoramica sul programma',
        description:
          "I proprietari di case contattano Enphase per nuove installazioni, aggiornamenti e manutenzione regolare del sistema. In qualità di partner di Enphase, ora hai l'opportunità di servire questi proprietari di casa attraverso l'Enphase Leads, che ti metterà in contatto con potenziali proprietari di case. Esamina i seguenti termini chiave e specifica le tue preferenze per questo programma."
      },
      keyProgramTerms: {
        title: 'Termini chiave del programma',
        enphaseProduct: "Nell'ambito del programma devono essere utilizzati solo prodotti Enphase",
        appointment: 'Enphase assisterà con la pianificazione degli appuntamenti e fornirà il supporto necessario',
        contact:
          'Ci si aspetta che gli installatori rispondano e contattino ciascun lead inviando un preventivo entro 2 giorni lavorativi',
        project:
          'Il profilo del cliente e i dettagli del progetto saranno forniti per ciascun lead prima del primo contatto',
        verifiedAccount: 'Enphase fornirà lead qualificati gratuiti per la tua area di assistenza'
      },
      TurnKey: {
        title: 'Servizi chiavi in mani',
        description:
          "Per Servizi chiavi in mano si intende che l'installatore consegna tutte le distinte per materiali, progettazione, permessi, installazione e messa in servizio applicabili. L'installatore effettua la valutazione del progetto e del sito prima di presentare un preventivo dettagliato. Il prezzo indicato include il costo totale stimato per il proprietario per il sistema da attivare.",
        solar: {
          indicativePricing: 'Fascia di prezzo indicativa per watt',
          quoteSizeIn: 'kW',
          main: 'Impianto solare - Installazione',
          sub: 'Installazione di un nuovo impianto solare.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installatore',
              sub:
                'Fornisce il prezzo chiavi in mano e presenta tutte le distinte dei materiali, come quelle per moduli, microinverter (o in alternativa moduli CA), box IQ Combiner, kit di accessori, interruttori di circuito, modem cellulare, cavi e montaggi in rack.'
            },
            assumptions: {
              main: 'Presupposti',
              sub:
                "La fascia di prezzo si intende per un sito tipico e non include l'aggiornamento del quadro principale e i tetti di tipo speciale."
            }
          }
        },
        storage: {
          indicativePricing: 'Fascia di prezzo indicativa per kWhr',
          indicativePricingStorageSlabs: 'Prezzo indicativo per kWh',
          main: 'Spazio di accumulo - Installazione',
          quoteSizeIn: 'kWh',
          sub: 'Installazione di un nuovo spazio di accumulo',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installatore',
              sub:
                'Fornisce il prezzo chiavi in mano e presenta tutte le distinte dei materiali come quelle per Spazio di accumulo Encharge, interruttore Enpower, modem cellulare, kit di accessori e cavi.'
            },
            assumptions: {
              main: 'Presupposti',
              sub: "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale."
            }
          }
        },
        microinverter: {
          indicativePricing: 'Fascia di prezzo indicativa per watt',
          main: 'Microinverter - Aggiornamento',
          quoteSizeIn: 'kW',
          sub:
            'Aggiornamento del microinverter per un impianto solare della serie M (ad es. M-215, M-250) su un nuovo impianto solare basato su IQ, che in genere accompagna un intervento di tipo "Spazio di accumulo - Installazione"',
          sub2:
            'Aggiornamento del microinverter per un impianto solare della serie M (ad es. M-215, M-250) su un nuovo impianto solare basato su IQ',
          subUS:
            'Aggiornamento di un microinverter per un impianto solare esistente per convertirlo in un nuovo impianto solare basato su IQ.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installatore',
              sub: 'Fornisce il prezzo chiavi in mano e presenta tutte le distinte dei materiali.'
            },
            assumptions: {
              main: 'Presupposti',
              sub:
                "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale e del pannello solare."
            }
          }
        }
      },
      installationOnly: {
        title: 'Servizi di sola installazione (per i programmi speciali)',
        titleUS: 'Servizi di sola installazione',
        sub: '(Ad es. proprietari di casa con pannelli solari M-190, amici e parenti Enphase di dipendenti)',
        description:
          "Per Servizi di sola installazione si intende che il proprietario di casa ottiene tutte le distinte dei materiali dal negozio Enphase. Tutti gli altri materiali e servizi vengono forniti dall'installatore (cablaggio, montaggio su rack, progettazione, permessi, installazione e messa in servizio, a seconda dei casi).",
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Fascia di prezzo indicativa per la sola installazione per watt',
          main: 'Impianto solare - Installazione',
          sub:
            'Nuova installazione per programmi speciali o aggiornamento completo di un impianto solare M-190/M-210/M-175/D380',
          subUS: 'Installazione di un nuovo impianto solare.',
          details: {
            homeOwner: {
              main: 'Proprietario di casa',
              sub:
                'Acquisisce dal negozio Enphase tutte le distinte dei materiali, ad esempio quelle per moduli CA, box IQ\u200b Combiner, kit di accessori e interruttori di circuito.'
            },
            installer: {
              main: 'Installatore',
              sub: 'Fornisce montaggio in rack, cablaggio, permessi, installazione e messa in servizio.'
            },
            assumptions: {
              main: 'Presupposti',
              sub:
                "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale e l'installazione su tetti di tipo speciale."
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Fascia di prezzo indicativa per la sola installazione per kWhr',
          indicativePricingStorageSlabs: 'Prezzo indicativo per la sola installazione per kWh',
          main: 'Spazio di accumulo - Installazione',
          sub:
            'Spazio di accumulo aggiunto a un impianto solare esistente per programmi speciali o per un impianto solare M-190/M-210/M-175/D380',
          subUS: 'Installazione di un nuovo spazio di accumulo',
          details: {
            homeOwner: {
              main: 'Proprietario di casa',
              sub:
                'Acquisisce le distinte dei materiali necessarie dal negozio Enphase, ad esempio quelle per spazio di accumulo Encharge, interruttore Enpower, kit di accessori, gateway Envoy (se necessario, box IQ Combiner, modem cellulare e/o CT di consumo)\u200b.'
            },
            installer: {
              main: 'Installatore',
              sub: 'Fornisce permessi, installazione e messa in servizio.'
            },
            assumptions: {
              main: 'Presupposti',
              sub: "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale."
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Fascia di prezzo indicativa per la sola installazione per watt',
          main: 'Microinverter - Aggiornamento',
          sub: `Aggiornamento del microinverter per un impianto solare M-190/M-210/M-175/D380 su un nuovo impianto solare basato su IQ, che in genere accompagna un intervento di tipo "Spazio di accumulo - Installazione"`,
          sub2:
            'Aggiornamento del microinverter per un impianto solare della serie M (ad es. M-215, M-250) su un nuovo impianto solare basato su IQ',
          subUS:
            'Aggiornamento di un microinverter per un impianto solare esistente per convertirlo in un nuovo impianto solare basato su IQ.',
          details: {
            homeOwner: {
              main: 'Proprietario di casa',
              sub:
                'Acquisisce dal negozio Enphase le distinte dei materiali necessarie, ad esempio quelle per microinverter, box IQ\u200b Combiner, kit di accessori e interruttori di circuito.'
            },
            installer: {
              main: 'Installatore',
              sub: 'Fornisce permessi, sostituzione, nuova messa in servizio e riciclo di vecchi microinverter.\u200b'
            },
            assumptions: {
              main: 'Presupposti',
              sub:
                "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale e le modifiche al montaggio su rack."
            }
          }
        }
      },
      omServices: {
        title: 'Servizi O&M Enphase',
        om: {
          main: 'Autorizzazione ai servizi O&M Enphase',
          pre: '- Inclusi i sistemi orfani',
          sub:
            "I servizi Operations and Maintenance (O&M) includono l'assistenza e la manutenzione dei sistemi Enphase e Orfani esistenti (siti con un installatore inattivo). A tutti i lead O&M verranno forniti i dettagli completi del sito e la cronologia dell'assistenza. Per tutti i lead O&M si applica la garanzia dei prodotti Enphase standard. La precedente garanzia da difetti di fabbricazione non si applica ai sistemi orfani."
        }
      },
      otherServices: {
        title: 'Altre preferenze',
        buy: 'Desideriamo acquistare i Prodotti da',
        acModule: {
          main: 'Vogliamo installare moduli CA energizzati Enphase',
          sub1: 'I moduli CA energizzati Enphase\xa0',
          sub2:
            "combinano la più recente tecnologia all'avanguardia dei microinverter Enphase con pannelli solari ad alta efficienza. Combinano estetica e prestazioni in un prodotto elegante che riduce i tempi di installazione combinando l'inverter e il pannello in un'unica unità. Selezionando questa opzione, Enphase ti abbinerà a proprietari di casa che desiderano installare moduli CA."
        },
        enstore: {
          main: 'Negozio Enphase',
          sub1: 'Il negozio Enphase\xa0',
          sub2:
            'è uno sportello unico per i prodotti solari e di accumulo con consegna garantita. Il negozio non richiede nessun ordine minimo in termini di quantità e offre consegna in tempo reale e tracciamento online.',
          subIndia: `is a one-stop-shop for Solar products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Distributori Enphase',
          sub1: 'I distributori Enphase',
          sub2:
            '\xa0Forniscono tutti i prodotti Enphase e altri accessori richiesti per la tua soluzione solare e di accumulo',
          subIndia: ` supply all Enphase products and other required accessories for your Solar solution​`
        },
        permitAssistance: {
          main: 'Siamo interessati al Permit Assistance Service di Enphase',
          sub:
            "Enphase ti assisterà con i pacchetti Solar and Storage Permit per i tuoi siti che potrai inviare all'autorità locale per l'approvazione."
        },
        financeProvider: {
          main: 'Offriamo ai proprietari di casa opzioni di finanziamento',
          no: 'No',
          yes: 'Sì',
          financeProvider: 'Fornitori di finanziamenti',
          others: 'Altri fornitori',
          addMultiple: 'fino a 3 (separati da virgola)',
          requiredSelection: 'Selezione richiesta',
          atLeastOneError: `Fornitori di servizi finanziari non validi (inserisci almeno un nome di fornitore quando è selezionato "Altri fornitori")`
        }
      },
      serviceArea: {
        name: 'AGGIUNGI AREE DI SERVIZI',
        sub: 'Nessuna area aggiunta',
        description:
          'Aggiungi le tue aree di servizi. Sono necessarie affinché Enphase possa abbinarti con potenziali lead proprietari di casa.'
      },
      qualifyLeads: {
        mainSection: 'Vuoi che il team Enphase qualifichi i lead telefonicamente prima di comunicarti i loro dettagli?',
        moreInfo: 'Facci sapere se ci sono informazioni specifiche che vorresti raccogliere dai lead.',
        infoWeCollect: 'Per sapere quali informazioni raccogliamo nell’ambito del nostro processo di qualificazione dei lead',
        subSection: 'Dopo la qualificazione, desideri che il lead venga trasferito a una persona del tuo team mentre i proprietari di casa sono al telefono con noi?',
        details: 'Seleziona un utente amministratore della tua azienda a cui dovremo trasferire i lead',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      }
    },
    textContentAu: {
      preference: {
        title: 'Preferenze del programma lead',
        caption: 'Limitazione di responsabilità',
        description:
          "Enphase mostrerà ai proprietari di case la fascia di prezzo da te fornita per ciascuna preferenza indicata di seguito. Verrà mostrata insieme a un'esclusione di responsabilità indicante che questo prezzo dipendente dal budget e riflette solo l'ambito di lavoro di un sistema tipico. Il prezzo effettivo è soggetto a modifiche a seconda della posizione, del tipo o della pendenza del tetto, dell'aggiornamento del quadro elettrico e della risistemazione del sistema in un luogo diverso."
      },
      programreview: {
        atleaseOne: '*seleziona almeno un servizio',
        title: 'Panoramica sul programma'
      },
      keyProgramTerms: {
        description:
          "I proprietari di case contattano Enphase per nuove installazioni, aggiornamenti e manutenzione regolare del sistema. In qualità di partner di Enphase, ora hai l'opportunità di servire questi proprietari di casa attraverso l'Enphase Leads, che ti metterà in contatto con potenziali proprietari di case. Esamina i seguenti termini chiave e specifica le tue preferenze per questo programma.",
        title: 'Termini chiave del programma',
        enphaseProduct: "Nell'ambito del programma devono essere utilizzati solo prodotti Enphase",
        appointment: 'Enphase assisterà con la pianificazione degli appuntamenti e fornirà il supporto necessario',
        contact:
          'Ci si aspetta che gli installatori rispondano e contattino ciascun lead inviando un preventivo entro 2 giorni lavorativi',
        project:
          'Il profilo del cliente e i dettagli del progetto saranno forniti per ciascun lead prima del primo contatto',
        verifiedAccount: 'Enphase fornirà lead qualificati gratuiti per la tua area di assistenza'
      },
      TurnKey: {
        title: 'Servizi chiavi in mani',
        description:
          "Per Servizi chiavi in mani si intende la fornitura di una distinta dei materiali, ad esempio per progettazione del sistema, permessi, installazione e messa in servizio, in base ai casi. L'installatore effettua la valutazione del progetto e del sito prima di presentare un preventivo dettagliato. Il prezzo indicato include il costo totale stimato per il proprietario per l'attivazione di un sistema",
        solar: {
          indicativePricing: 'Fascia di prezzo indicativa per watt',
          quoteSizeIn: 'kW',
          main: 'Impianto solare - Installazione',
          sub: 'Installazione di un nuovo impianto solare.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installatore',
              sub:
                'Fornisce prezzo chiavi in mano e procura tutte le distinte dei materiali necessarie, ad esempio quelle per moduli, microinverter, accessori, interruttori di circuito, cavi e montaggio in rack.'
            },
            assumptions: {
              main: 'Presupposti',
              sub:
                "La fascia di prezzo si intende per un sito tipico e non include l'aggiornamento del quadro principale e i tetti di tipo speciale."
            }
          }
        },
        storage: {
          indicativePricing: 'Fascia di prezzo indicativa per kWhr',
          main: 'Spazio di accumulo - Installazione',
          quoteSizeIn: 'kWh',
          sub: 'Installazione di un nuovo spazio di accumulo',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installatore',
              sub:
                "Fornisce prezzo chiavi in mano e procura tutte le distinte dei materiali necessarie, ad esempio quelle per spazio di accumulo ACB, staffa, cablaggio e interruttori di circuito.'principale: 'Presupposti",
              assumptions: {
                main: 'Presupposti',
                sub:
                  "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale.'indicativoPrezzo: 'Fascia di prezzo indicativa per watt"
              }
            }
          },
          microinverter: {
            main: 'Microinverter - Aggiornamento',
            quoteSizeIn: 'kW',
            sub:
              'Aggiornamento del microinverter per un impianto solare della serie M (ad es. M-215, M-250) su un nuovo impianto solare basato su IQ, che in genera accompagna un intervento di tipo "Spazio di accumulo - Installazione"',
            details: {
              homeOwner: {
                main: '',
                sub: ''
              },
              installer: {
                main: 'Installatore',
                sub: 'Fornisce il prezzo chiavi in mano e presenta tutte le distinte dei materiali.'
              },
              assumptions: {
                main: 'Presupposti',
                sub:
                  "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale e del pannello solare."
              }
            }
          },
          solarExpansion: {
            indicativePricing: 'Fascia di prezzo indicativa per watt',
            quoteSizeIn: 'kW',
            main: 'Espansione impianto solare',
            sub: 'Espansione di un impianto solare Enphase e non esistente',
            details: {
              homeOwner: {
                main: '',
                sub: ''
              },
              installer: {
                main: 'Installatore',
                sub: 'Fornisce il prezzo chiavi in mano e presenta tutte le distinte dei materiali.'
              },
              assumptions: {
                main: 'Presupposti',
                sub:
                  "La fascia di prezzo si intende per un sito tipico e non include l'aggiornamento del quadro principale e i tetti di tipo speciale."
              }
            }
          }
        },
        installationOnly: {
          title: 'Servizi di sola installazione (per i programmi speciali)',
          sub:
            '(Ad es. sistemi orfani, che devono essere sostituiti/riparati, aggiornamento della batteria, aggiornamento di Envoy)',
          description:
            "Per Servizi di sola installazione si intende che il proprietario di casa ottiene tutte le distinte dei materiali dal negozio Enphase. Tutti gli altri materiali e servizi vengono forniti dall'installatore (cablaggio, montaggio su rack, progettazione, permessi, installazione e messa in servizio, a seconda dei casi).",
          solar: {
            quoteSizeIn: 'kW',
            indicativePricing: 'Fascia di prezzo indicativa per la sola installazione per watt',
            main: 'Impianto solare - Installazione',
            sub:
              'Nuove installazioni per programmi speciali, ad esempio lead raccomandati da clienti, installatori e clienti Enphase.',
            details: {
              homeOwner: {
                main: 'Proprietario di casa',
                sub:
                  'Acquisisce dal negozio Enphase le distinte dei materiali necessarie, ad esempio quelle per microinverter, kit di accessori e interruttori di circuito.'
              },
              installer: {
                main: 'Installatore',
                sub: 'Fornisce moduli, montaggio in rack, cablaggio, permessi, installazione e messa in servizio.'
              },
              assumptions: {
                main: 'Presupposti',
                sub:
                  "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale e l'installazione su tetti di tipo speciale."
              }
            }
          },
          storage: {
            quoteSizeIn: 'kWh',
            indicativePricing: 'Fascia di prezzo indicativa per la sola installazione per kWhr',
            main: 'Spazio di accumulo - Espansione o installazione',
            sub:
              'Espansione o installazione di uno spazio di accumulo ACB su un impianto solare esistente per programmi speciali',
            details: {
              homeOwner: {
                main: 'Proprietario di casa',
                sub:
                  'Acquisisce dal negozio Enphase le distinte dei materiali necessarie, come quelle per spazio di accumulo ACB, staffa.'
              },
              installer: {
                main: 'Installatore',
                sub: 'Fornisce installazione e messa in servizio.'
              },
              assumptions: {
                main: 'Presupposti',
                sub: "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale."
              }
            }
          },
          microinverter: {
            quoteSizeIn: 'kW',
            indicativePricing: 'Fascia di prezzo indicativa per la sola installazione per watt',
            main: 'Microinverter - Aggiornamento',
            sub:
              'Aggiornamento del microinverter per un impianto solare M-190/M-210/M-175/D380 su un nuovo impianto solare basato su IQ, che in genere accompagna un intervento di tipo "Spazio di accumulo - Installazione"',
            details: {
              homeOwner: {
                main: 'Proprietario di casa',
                sub:
                  'Acquisisce dal negozio Enphase le distinte dei materiali necessarie, ad esempio quelle microinverter, box IQ\u200b Combiner, kit di accessori e interruttori di circuito.'
              },
              installer: {
                main: 'Installatore',
                sub: 'Fornisce permessi, sostituzione, nuova messa in servizio e riciclo di vecchi microinverter.\u200b'
              },
              assumptions: {
                main: 'Presupposti',
                sub:
                  "La fascia di prezzo indicativa non include l'aggiornamento del quadro principale e le modifiche al montaggio su rack."
              }
            }
          }
        },
        omServices: {
          title: 'Servizi O&M Enphase',
          om: {
            main: 'Autorizzazione ai servizi O&M Enphase',
            pre: '- Inclusi i sistemi orfani',
            sub:
              "I servizi Operations and Maintenance (O&M) includono l'assistenza e la manutenzione dei sistemi Enphase e Orfani esistenti (siti con un installatore inattivo). A tutti i lead O&M verranno forniti i dettagli completi del sito e la cronologia dell'assistenza. Per tutti i lead O&M si applica la garanzia dei prodotti Enphase standard."
          }
        },
        otherServices: {
          title: 'Altre preferenze',
          buy: 'Voglio acquistare prodotti da',
          acModule: {
            main: 'Voglio installare moduli CA energizzati Enphase',
            sub1: 'I moduli CA energizzati Enphase\xa0',
            sub2:
              "combinano la più recente tecnologia all'avanguardia dei microinverter Enphase con pannelli solari ad alta efficienza. Combinano estetica e prestazioni in un prodotto elegante che riduce i tempi di installazione combinando l'inverter e il pannello in un'unica unità. Selezionando questa opzione, Enphase ti abbinerà a proprietari di casa che desiderano installare moduli CA."
          },
          enstore: {
            main: 'Negozio Enphase',
            sub1: 'Negozio Enphase\xa0',
            sub2:
              'è uno sportello unico per i prodotti solari e di accumulo con consegna garantita. Il negozio non richiede nessun ordine minimo in termini di quantità e offre consegna in tempo reale e tracciamento online.'
          },
          distributor: {
            main: 'Distributori Enphase',
            sub1: 'I distributori Enphase',
            sub2:
              '\xa0Forniscono tutti i prodotti Enphase e altri accessori richiesti per la tua soluzione solare e di accumulo'
          }
        },
        serviceArea: {
          name: 'AGGIUNGI AREE DI SERVIZI',
          sub: 'Nessuna area aggiunta',
          description:
            'Aggiungi le tue aree di servizi. Sono necessarie affinché Enphase possa abbinarti con potenziali lead proprietari di casa.'
        }
      }
    },
    getLink: `Ricevi il link`,
    linkSENewLeads: `Link di System Estimator per nuovi lead`,
    shareSELink: `Condividi questo link con i tuoi clienti per aiutarli a stimare le dimensioni del loro sistema Enphase e inviare i loro dettagli per ottenere un lead nel tuo Enlighten Manager`
  }
};

export default leadPreferences;
